import React, { useEffect, useState } from "react";
import { Flex, ResponsiveSVG } from "ui/acro";
import PlaylistFilled from "../../../../assets/images/PlaylistFilled.svg";
import PlaylistNew from "../../../../assets/images/PlaylistNew.svg";
import Instructor from "../../../../assets/images/content-instructors.svg";
import Series from "../../../../assets/images/content-series.svg";
import ChevronSvg from "../../../../assets/images/chevron.svg";
import styled from "styled-components";
import Drawer from "../../../components_v2/Drawer/Drawer";
import { Button } from "react-bootstrap";
import { axios } from "api";

const PlaylistBack = styled.button`
  font-size: 18px;
  color: #000;
  font-family: "Proxima-Nova";
  font-style: normal;
  font-weight: 600;
  line-height: 135%;
  display: flex;
  border-width: 0;
  margin-left: -18px;
  text-transform: uppercase;
  background: #fff;
`;

const FooterWrapper = styled.div`
  position: fixed;
  width: calc(100% - 48px);
  margin-bottom: 25px;
  margin-top: 25px;
`;

const SavePlaylistButton = styled(Button)({
  fontSize: ["18px"],
  fontFamily: "Proxima-nova",
  textTransform: "uppercase",
  color: (props) => (props.disabled ? "#4c4c4c" : "#fff"),
  background: (props) => (props.disabled ? "#ebebeb" : "#000"),
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "24px",
  letterSpacing: "0.9px",
  padding: "12px 32px",
  width: "100%",
});

const CreatePlaylistButton = styled(Flex)`
  font-family: ${(props) => props.theme.fonts.Proxima};

  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.396px;
  border: 0px solid #a3a3a3;
  gap: 16px;
  align-items: center;
  cursor: pointer;
    padding: 12px 0px;
`;

const CreatePlaylistLink = styled.a`
  font-family: ${(props) => props.theme.fonts.Proxima};
  color: #000;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.396px;
  border: 0px solid #a3a3a3;
  display: flex;
  gap: 16px;
  align-items: center;
  cursor: pointer;
    padding: 12px 0px;
  
`;

const PlayListClassAction = ({
  isOpen,
  onClose,
  id,
  uuid,
  title,
  dataObj,
  author,
  userIsAuthor,
  setUpdateClassList,
}) => {
  const [isPlaylist, setIsPlayList] = useState(false);
  const [playList, setPlayList] = useState([]);
  const [selectedPlay, setSelectedPlay] = useState([...dataObj.playlistIds]);
  const [playListTitle, setPlayListTitle] = useState(
    `New Playlist ${new Date().toLocaleDateString("en-GB")}`,
  );

  useEffect(() => {
    setPlayListTitle(() => title);
  }, [title]);

  useEffect(() => {
    fetchData();
  }, []);

  const closeDrawer = () => {
    onClose();
    setIsPlayList(false);
  };

  const fetchData = async () => {
    let params = {
      scope: "class_page",
    };
    try {
      const res = await axios.get(`playlists/me`, { params });
      if (res.status === 200) {
        setPlayList(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedPlay((prevItems) => [...prevItems, value]);
    } else {
      setSelectedPlay((prevItems) => prevItems.filter((e) => e !== value));
    }
  };

  const savePlaylist= async ()=>{
    try {
      const res = await axios.post(`playlists/update_class_playlist`, {
        plan_entry_id: dataObj?.id,
        playlist_ids: selectedPlay,
      });
      if (res.status === 200) {
        closeDrawer();
      }
    } catch (e) {
      console.error(e);
    }
  }

  const removeFromPlaylist = async () => {
    try {
      const res = await axios.delete(
        `/playlists/${uuid}/entries/${dataObj?.id}`,
      );
      if (res.status === 204) {
        setUpdateClassList((data) => !data);
        closeDrawer();
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Drawer
      isOpen={isOpen}
      title={dataObj.title}
      dataObj={dataObj}
      author={author}
      onClose={() => {
        closeDrawer();
      }}
    >
      <div>
        {!isPlaylist ? (
          <>
            {userIsAuthor && (
              <CreatePlaylistButton onClick={removeFromPlaylist}>
                <ResponsiveSVG
                  SVG={PlaylistFilled}
                  width="25px"
                  height="25px"
                />
                Remove From This Playlist
              </CreatePlaylistButton>
            )}
            <CreatePlaylistButton onClick={() => setIsPlayList(true)}>
              <ResponsiveSVG SVG={PlaylistNew} width="25px" height="25px" />
              Add to Another Playlist
            </CreatePlaylistButton>
            
            <CreatePlaylistLink href={`/series/${dataObj?.plan?.slug}`}>
              <ResponsiveSVG SVG={Series} width="25px" height="25px" />
              Go to Series
            </CreatePlaylistLink>
          </>
        ) : (
          <>
            <PlaylistBack onClick={() => setIsPlayList(false)}>
              <ResponsiveSVG
                SVG={ChevronSvg}
                style={{
                  cursor: "pointer",
                }}
                width="24px"
                height="24px"
              />
              <div>Add to Playlist</div>
            </PlaylistBack>
            <div className="radioWrapper">
              {playList?.filter((i) => i.uuid !== uuid)?.map((item) => (
                <label class="radioContainer" key={item.uuid}>
                  {item.title}
                  <input
                    type="checkbox"
                    name="checkbox"
                    value={item.uuid}
                    checked={selectedPlay.includes(item.uuid)}
                    onChange={handleChange}
                  />
                  <span class="checkmark"></span>
                </label>
              ))}
            </div>
            <FooterWrapper>
              <SavePlaylistButton onClick={savePlaylist}>Save</SavePlaylistButton>
            </FooterWrapper>
          </>
        )}
      </div>
    </Drawer>
  );
};
export default PlayListClassAction;
